import React, { Dispatch, useCallback, useEffect, useState } from "react";
import { ChatFolderData } from "@sms/shared/chat/chat-folder.interface";
import { useDispatch, useSelector } from "react-redux";

import DefaultModal from "../../default-modal/default-modal.component";
import stylesForm from "../../../assets/styles/form.module.scss";

import { ChatSelectFoldersState } from "./chat-select-folders.types";

import { ApplicationStore } from "~/app/application.store";
import { setChatSelectFoldersModalIsOpen } from "~/app/modals/modals.actions";
import { selectChatChangeFoldersAction } from "~/app/chat/folders/folders.actions";

const ChatSelectFoldersComponent: React.FC = () => {
  const dispatch: Dispatch<any> = useDispatch();

  const folders: ChatFolderData[] = useSelector((state: ApplicationStore) => state.chatFolders.folders);
  const chatSelectFoldersIsOpen: boolean = useSelector(
    (state: ApplicationStore) => state.modals.setChatSelectFoldersModalIsOpen
  );
  const selectChatFolders: ChatFolderData[] = useSelector(
    (state: ApplicationStore) => state.chatFolders.selectChatFolders
  );

  const [selectChatFoldersData, setSelectChatFoldersData]: [
    ChatSelectFoldersState,
    React.Dispatch<React.SetStateAction<ChatSelectFoldersState>>
  ] = useState<ChatSelectFoldersState>([]);

  const handleChatSelectFoldersModalIsOpen: (isOpen: boolean) => void = useCallback(
    (isOpen: boolean): void => {
      dispatch(setChatSelectFoldersModalIsOpen(isOpen));
    },
    [dispatch]
  );
  const handleSelectChatChangeFoldersAction: (chatFolders: ChatFolderData[]) => void = useCallback(
    (chatFolders: ChatFolderData[]): void => {
      dispatch(selectChatChangeFoldersAction(chatFolders));
    },
    [dispatch]
  );

  const handleChange: (folder: ChatFolderData) => void = (folder: ChatFolderData): void => {
    const selectedChatFolders: ChatFolderData[] = [...selectChatFoldersData];

    const findChatFolderId: number = selectedChatFolders.findIndex((item: ChatFolderData) => item.id === folder.id);
    if (findChatFolderId > -1) {
      selectedChatFolders.splice(findChatFolderId, 1);
    } else {
      selectedChatFolders.push(folder);
    }

    setSelectChatFoldersData(selectedChatFolders);
  };

  const handleSelectChatChangeFolders: () => void = (): void => {
    handleSelectChatChangeFoldersAction(selectChatFoldersData);
  };

  useEffect(() => {
    setSelectChatFoldersData([...selectChatFolders]);
  }, [selectChatFolders]);

  return (
    <DefaultModal
      title="Select Folders"
      modalState={chatSelectFoldersIsOpen}
      setModalState={handleChatSelectFoldersModalIsOpen}
      action={handleSelectChatChangeFolders}
    >
      <div className={stylesForm.inputGroup}>
        {folders.map((folder, index) => {
          return (
            <label className={stylesForm.radioWrapper} key={index}>
              <input
                type="checkbox"
                name="chatFoldersState"
                value={folder.id}
                checked={selectChatFoldersData.some(item => item.id === folder.id) ?? false}
                onChange={(): void => handleChange(folder)}
              />
              <span>{folder.title}</span>
            </label>
          );
        })}
      </div>
    </DefaultModal>
  );
};

export default ChatSelectFoldersComponent;
